import React, { useState, useEffect } from "react";
import { AppBar, Box, Button, FormControl, FormControlLabel, Link,makeStyles, Radio, RadioGroup, TextField, Toolbar, Typography } from '@material-ui/core';
import Autocomplete from '@mui/material/Autocomplete';

import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';

const theme = createTheme({
  palette: {
    primary: {
      main: "#00947b",
    } ,
    secondary: {
      main: "#65c271",
    } 
  },
});


const useStyles = makeStyles(() => ({
  typographyStyles: {
    flex: 1,
  },
  footerStyles: {
    width: "100%",
    position: "absolute",
    bottom: 0,
    backgroundColor: theme.palette.secondary.main,
    textAlign:"center",
  },
  boxStyles: {
    marginTop: "2vw",
  },
  boxStylesDesc: {
    marginTop: ".5vw",
    lineHeight: "1.5em",
    marginBottom: "2vw",
    fontSize:"0.9em",
  },
}));



const ProductDisplay = () => {
  const classes = useStyles();
  const [name, setName] = useState('礼拝献金');
  const [amount, setAmount] = useState(1000);

  const handleNameChange = (e,newValue) => {

    if (typeof newValue === 'string') {
      setName(newValue);
    }
  }
  const handleAmountChange = (e,newValue) => {

    if (typeof newValue === 'string') {
      let v = newValue;
      v = v.replace(/[０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 65248)).replace(/\D/g, '');
      setAmount(v);
    }
  }

  const kenkin = [
    { label: '礼拝献金' },
    { label: '月定献金' },
    { label: 'イースター献金' },
    { label: 'クリスマス献金' },
    { label: 'ペンテコステ献金' },
    { label: '誕生日献金' },
    { label: '受洗記念日献金' },
    { label: '結婚記念日献金' },
    { label: '建築献金' },
    { label: 'オルガン維持献金' },
    { label: '感謝献金' },
    { label: '召天記念日献金' },
    { label: '夏期特別献金' },
    { label: 'その他の献金' },
  ];

  const gaku = [
    { label: '500' },
    { label: '1000' },
    { label: '2000' },
    { label: '3000' },
    { label: '5000' },
    { label: '10000' },
  ];


  return (
    <>
        <FormControl fullWidth>
          <Box className={classes.boxStyles}>
            <Autocomplete
              id="combo-box-kenkin"
              value={name}
              freeSolo
              autoSelect
              options={kenkin}
              //sx={{ width: 300 }}
              onChange={handleNameChange}
              renderInput={(params) => <TextField {...params} label="献金目的" variant="outlined" />}
            />
          </Box>
          <Box className={classes.boxStylesDesc}>
          献金内訳を上記に入力してください。<br />または入力スペースをクリックして表示される一覧から献金内訳を選択してください。
          </Box>
        </FormControl>

        <FormControl fullWidth>
          <Box className={classes.boxStyles}>
            <Autocomplete
              id="combo-box-amount"
              value={amount}
              freeSolo
              autoSelect
              options={gaku}
              //sx={{ width: 300 }}
              onChange={handleAmountChange}
              renderInput={(params) => <TextField {...params} label="献金額" variant="outlined" />}
            />
          </Box>
          <Box className={classes.boxStylesDesc}>
          献金額を上記に入力してください。<br />または入力スペースをクリックして表示される一覧から献金額を選択してください。
          </Box>
        </FormControl>


      <form action="/kenkin/create-checkout-session.php" method="POST">
        <input type="hidden" name="name" value={name} />
        <input type="hidden" name="amount" value={amount} />

        <FormControl fullWidth>
          <TextField
            label="通信欄"
            multiline
            rows={3}
            variant="outlined"
            name="comment"
          />
        </FormControl>

        <FormControl fullWidth>
          <Box className={classes.boxStyles}>
            <RadioGroup
              row
              defaultValue="0"
              name="mode"
            >
              <FormControlLabel value="0" control={<Radio />} label="一回献金" />
              <FormControlLabel value="1" control={<Radio />} label="継続献金（毎月）" />
              <FormControlLabel value="2" control={<Radio />} label="継続献金（毎年）" />
            </RadioGroup>
          </Box>
        </FormControl>

        <FormControl fullWidth>
          <Box className={classes.boxStyles}>
            <Button type="submit" color="primary" variant="contained" fullWidth>
              献金する
            </Button>
          </Box>
        </FormControl>

      </form>
    </>
  );
};

const Message = ({ message }) => (
  <>
    <p>{message}</p>
    <Link href="/">TOPへ</Link>
  </>
);

export default function App() {
  const [message, setMessage] = useState("");
  const classes = useStyles();

  useEffect(() => {
    // Check to see if this is a redirect back from Checkout
    const query = new URLSearchParams(window.location.search);

    if (query.get("success")) {
      setMessage("献金ありがとうございます。");
    }

    if (query.get("canceled")) {
      setMessage(
        "キャンセルしました。"
      );
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <AppBar position="static">
        <Toolbar>
          <Typography variant="h5" component="h1" className={classes.typographyStyles}>
            翠ヶ丘教会 オンライン献金
          </Typography>
        </Toolbar>
      </AppBar>
 
      <Container maxWidth="sm">
        <Box className={classes.boxStyles}>
          {
            message ? 
              <Message message={message} />
             : 
              <ProductDisplay />
            
          }
        </Box>
      </Container>

      <Box className={classes.footerStyles}>
        Midorigaoka Church All right reserved.   e-mail: <a href="mailto:info@midorigaoka.jp">info@midorigaoka.jp</a>
      </Box>

    </ThemeProvider>

  )
  
}
